<script lang="ts">
	export let active = false;
	export let hover = false;

</script>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
	<g>
		<g transform="translate(0 15.677)">
			<circle class:active class:hover cx="2.161" cy="2.161" r="2.161" />
		</g>
		<g transform="translate(3.919 8.818)">
			<circle class:active class:hover cx="2.161" cy="2.161" r="2.161" />
		</g>
		<g transform="translate(11.757 11.758)">
			<circle class:active class:hover cx="2.161" cy="2.161" r="2.161" />
		</g>
		<g transform="translate(15.677)">
			<circle class:active class:hover cx="2.161" cy="2.161" r="2.161" />
		</g>
		<g>
			<path
				class:active
				class:hover
				d="M48.883 230.751a.4.4 0 0 1-.347-.591l3.957-7.132a.4.4 0 0 1 .5-.173l7.647 3.245 3.636-11.75a.4.4 0 1 1 .759.235l-3.766 12.17a.4.4 0 0 1-.535.248l-7.722-3.276-3.783 6.819a.4.4 0 0 1-.346.205z"
				transform="translate(-46.76 -212.476)" />
		</g>
	</g>
</svg>

<style lang="scss">
	circle,
	path {
		transition: all 0.5s;
		fill: #bcbfc3;

		&.hover {
			fill: var(--default-hover-btn-1);
		}

		&.active {
			fill: var(--signature-blue) !important;
		}
	}

</style>
